import { render, staticRenderFns } from "./ConfirmationFormModal.vue?vue&type=template&id=15eda4d4&"
import script from "./ConfirmationFormModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports